define('presentation/welcome/facades/onboardingAvailabilityFacade',[
    'businessServices/onboarding/liveReceptionistOnboardingSingleton',
    'common/promises/promiseFactory',
], function() {

    const _liveReceptionistOnboardingState = require('businessServices/onboarding/liveReceptionistOnboardingSingleton');

    let _promiseFactory = null;

    const _getLiveReceptionistOnboarding = () => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.getLiveReceptionistOnboarding()
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _resetBusinessHours = () => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.resetBusinessHours()
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveBusinessHours = (dayOfWeek, openTime, closeTime) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveBusinessHours(dayOfWeek, openTime, closeTime)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveCallerFollowUp = (callerFollowUp) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveCallerFollowUp(parseInt(callerFollowUp))
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveCallerFollowUpOther = (callerFollowUpOther) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveCallerFollowUpOther(callerFollowUpOther)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveTimeZone = (timeZone) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveTimeZone(timeZone)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function() {
        let self = this;
        self.init = _init;

        self.getLiveReceptionistOnboarding = _getLiveReceptionistOnboarding;
        self.resetBusinessHours = _resetBusinessHours;
        self.saveBusinessHours = _saveBusinessHours;
        self.saveCallerFollowUp = _saveCallerFollowUp;
        self.saveCallerFollowUpOther = _saveCallerFollowUpOther;
        self.saveTimeZone = _saveTimeZone;
    };
});

